import { DeleteModal } from "UIKit";

import { useFileOperations } from "Hooks";
import { errorStore } from "Stores/ErrorStore";
import { useRequestStatus } from "Utilities";

interface DeleteHospitalModalProps {
  hospital: any;
  onCloseModal(): void;
}

export const DeleteHospitalModal: React.FC<DeleteHospitalModalProps> = ({
  hospital,
  onCloseModal,
}) => {
  const { removeFile } = useFileOperations();
  const { isLoading, isSuccessful, error, setRequestStatus } = useRequestStatus();

  const onDelete = () => {
    setRequestStatus({ status: "pending", error: "" });

    removeFile({
      variables: {
        id: hospital.id,
        parentID: hospital.parentID,
      },
    })
      .then(() => {
        setRequestStatus({ status: "success", error: "" });
      })
      .catch((error) => {
        const errorMessage = errorStore.captureError({
          error,
          source: "user",
          retryCallback: removeFile,
          retryParameters: {
            variables: {
              id: hospital.id,
              parentID: hospital.parentID,
            },
          },
        });
        setRequestStatus({ status: "error", error: errorMessage });
      });
  };

  return (
    <DeleteModal
      isLoading={isLoading}
      onDelete={onDelete}
      error={error}
      title={hospital.fileName}
      isSuccessful={isSuccessful}
      onCloseModal={onCloseModal}
      description="deleteModal_delete_hospital_description"
    />
  );
};
